import React from "react";
import BackArrow from "../../assets/svg/BackArrow";
import "./SubpageBackButton.css";

export default function SubpageBackButton({ onClick, className = "" }) {
  return (
    <button
      type="button"
      className={`subpage-back-btn${className ? ` ${className}` : ""}`}
      aria-label="Go back"
      onClick={onClick}
    >
      <BackArrow className="subpage-back-btn__icon" />
    </button>
  );
}
